const sectionMenus = {
  Section: () =>
    import(
      /* webpackChunkName: "section" */
      '../../components/section/Section'
    )
};

export default sectionMenus;
